/** @type {React.ComponentType} */
export default function SendIcon() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.19398 0.137848C0.846319 -0.455902 -0.49743 0.981598 0.182257 2.29019L2.64319 7.02457C2.81507 7.35269 3.13538 7.57535 3.50257 7.62222L10.3346 8.47769C10.4674 8.49332 10.569 8.6066 10.569 8.73941C10.569 8.87222 10.4674 8.98551 10.3346 9.00113L3.50257 9.8566C3.13538 9.90347 2.81507 10.1261 2.64319 10.4543L0.182257 15.1886C-0.49743 16.4972 0.84632 17.9308 2.19788 17.341L19.1979 9.88394C20.194 9.44644 20.194 8.03238 19.1979 7.59488L2.19398 0.137848Z"
        fill="#0033A0"
      />
    </svg>
  );
}
